import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatOptionModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { Route, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SearchComponent } from '../../components/search/search.component';
import { CvvCommonModule } from '../cvv-common/cvv-common.module';
import { SharedModule } from '../shared-module/shared.module';

const routes: Route[] = [{
    path: 'search',
    component: SearchComponent,
    children: [
      {path: 'create', component: SearchComponent, outlet: 'side'}
    ]
  }];

  @NgModule({
    imports: [
      CommonModule,
      RouterModule.forChild(routes),
      MatExpansionModule,
      MatFormFieldModule,
      MatButtonModule,
      MatInputModule,
      FormsModule,
      ReactiveFormsModule,
      ScrollingModule,
      MatSlideToggleModule,
      MatSelectModule,
      MatOptionModule,
      MatIconModule,
      MatButtonToggleModule,
      FontAwesomeModule,
      SharedModule,
      CvvCommonModule,
      MatProgressBarModule,
    ],
    declarations: [SearchComponent],
    exports:[SearchComponent]
  })
  export class SearchModule { }